import { ApiQueries, DiaryEntryType, EventItem, DaymapSkeleton } from "daymap-react";
import { useNavigate } from "react-router-dom";
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import GroupsIcon from '@mui/icons-material/Groups';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

import { DaymapTypes } from "daymap-react";
import { Box, Chip, Tooltip, Typography } from "@mui/material";
import { ReactNode, useState } from "react";
import React from "react";
type InterviewGroupItem = {
    GroupId: number,
    Title: string,
    HasBooking: boolean,
    BookedCount: number,
    From:Date,
    To:Date,
    Students: string[],
    Description?: string,
}

export default function Interviews() {
    const { isPending, data } = new ApiQueries.interviews.InterviewGroups().ToQuery();
    const navigate = useNavigate();
    let interviews:InterviewGroupItem[] | null = null

    if(data) {
        //Each student in an interview gets their own entry consolodate them
        let tempInterviews:{[key:number]: InterviewGroupItem} = {};

        data.forEach((x) => {
            if(tempInterviews[x.GroupID]){
                tempInterviews[x.GroupID].BookedCount += x.BookedCount;
                tempInterviews[x.GroupID].Students.push(x.Student.DisplaynameSurname)
                tempInterviews[x.GroupID].HasBooking = tempInterviews[x.GroupID].HasBooking || x.HasBookings;
            }
            else {
                let tempInterview:InterviewGroupItem = {
                    GroupId: x.GroupID,
                    Title: x.Title,
                    HasBooking: x.HasBookings,
                    BookedCount: x.BookedCount,
                    From:x.From,
                    To:x.To,
                    Students: [x.Student.DisplaynameSurname]
                }

                let description:string = ""
                switch(x.Status){
                    case DaymapTypes.interviews.GroupStatusEnum.Booking:
                    case DaymapTypes.interviews.GroupStatusEnum.BookingAllowTeachers:
                        description = "Interview is open for booking.";
                        break;
                    case DaymapTypes.interviews.GroupStatusEnum.Locked:
                        description = "Interview has been locked and changes cannot be made."
                        break;
                }
                if(description != "")
                    tempInterview.Description = description;



                tempInterviews[x.GroupID] = tempInterview;
            }
        });

        interviews = Object.values(tempInterviews);
    }

    if (isPending)
        return <DaymapSkeleton type="listitemswithheading" />

    if (!isPending && (!data || data!.length === 0))
        return null;

    return (
        <>
            <Typography sx={{ p: 1 }} variant="h3">Parent Teacher Interviews</Typography>
            <Box sx={{ display: 'flex', flexFlow: 'column', gap: 1 }}>
            {interviews && interviews!.map(i => {
                    let chips:ReactNode = (<React.Fragment key={i.GroupId +"_students"}>
                        <StudentChip students={i.Students} />
                        {i.HasBooking && <Chip key="bookings" size="small" label={`${i.BookedCount} interview${i.BookedCount > 1 ? "s" : ""} booked`} icon={<EventAvailableIcon />} />}
                        {!i.HasBooking && <Chip key="bookings" size="small" label={`No interviews booked`} icon={<EventBusyIcon />} />}
                    </React.Fragment>)

                    return (<EventItem 
                        onClick={() => navigate("/interviews/" + i.GroupId)}
                        key={i.GroupId}
                        eventType={DiaryEntryType.Interview}
                        title={i.Title}
                        date={i.From}
                        chips={chips}
                        description={i.Description != "" ? i.Description : undefined}
                    />)
                })}
            </Box>
        </>
    )
}

const StudentChip:React.FC<{students:string[]}> = ({students}) => {
    const [open, setOpen] = useState(false);

    let studentText = students.join(", ");
    let truncatedStudentText = (studentText.length > 10) ? studentText.slice(0, 7) + '...' : studentText;
    let icon:ReactNode = <PersonIcon />
    if(students.length == 2) {icon = <GroupIcon />}
    if(students.length > 2) {icon = <GroupsIcon />}

    return (
        <Tooltip
            title={studentText}
            open={open}
            onClick={(event) => { setOpen(!open); event.stopPropagation();}}
            disableInteractive
        >
            <Chip 
                key={students.length}
                label={truncatedStudentText} 
                size="small" 
                icon={icon}
            />
        </Tooltip>
    )

}